"use strict";

exports.__esModule = true;
exports.inputClassName = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _propTypes = require("prop-types");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames3 = require("classnames");

var _classnames4 = _interopRequireDefault(_classnames3);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var controlClassName = function controlClassName(_ref) {
  var _classnames;

  var loading = _ref.loading;

  var prefixCls = "control";

  var componentCls = (0, _classnames4.default)(prefixCls, (_classnames = {}, _classnames[prefixCls + "--loading"] = loading, _classnames));

  return componentCls;
};

var inputClassName = exports.inputClassName = function inputClassName(props) {
  var _classnames2;

  var className = props.className,
      multiLine = props.multiLine,
      underline = props.underline,
      boxed = props.boxed,
      warning = props.warning,
      error = props.error;


  var prefixCls = "textfield";

  /*eslint-disable no-nested-ternary */
  var variant = boxed ? "boxed" : underline ? "underline" : null;
  /*eslint-enable no-nested-ternary */

  var componentCls = (0, _classnames4.default)(prefixCls, (_classnames2 = {}, _classnames2[prefixCls + "--multi"] = multiLine, _classnames2[prefixCls + "--" + variant] = variant, _classnames2[prefixCls + "--error"] = error, _classnames2[prefixCls + "--warning"] = warning && !error, _classnames2), className);

  return componentCls;
};

var controlStyle = {
  position: "relative"
};

var iconStyle = {
  position: "absolute",
  right: 0
};

var Textfield = function (_React$Component) {
  _inherits(Textfield, _React$Component);

  function Textfield() {
    _classCallCheck(this, Textfield);

    return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
  }

  Textfield.prototype.focus = function focus() {
    // Explicitly focus the text input using the raw DOM API
    this.textInput.focus();
  };

  Textfield.prototype.render = function render() {
    var _this2 = this;

    var props = this.props;

    var multiLine = props.multiLine,
        loading = props.loading,
        rest = _objectWithoutProperties(props, ["multiLine", "loading"]);

    var Component = multiLine ? "textarea" : "input";
    var componentCls = inputClassName(props);

    delete rest.flat;
    delete rest.meta;
    delete rest.boxed;
    delete rest.error;
    delete rest.warning;
    delete rest.visible;
    delete rest.intl; //avoid complaints about invalid props on native elements

    return _react2.default.createElement(
      "div",
      { className: controlClassName(props) },
      _react2.default.createElement(Component, _extends({}, rest, {
        ref: function ref(input) {
          _this2.textInput = input;
        },
        className: componentCls
      }))
    );
  };

  return Textfield;
}(_react2.default.Component);

Textfield.propTypes = process.env.NODE_ENV !== "production" ? {
  className: _propTypes2.default.string,
  multiLine: _propTypes2.default.bool,
  underline: _propTypes2.default.bool,
  boxed: _propTypes2.default.bool,
  error: _propTypes2.default.any
} : {};

exports.default = Textfield;


//////////////////
// WEBPACK FOOTER
// ../node_modules/@cxagroup/casper/lib/components/textfield/textfield.js
// module id = 1349
// module chunks = 249